import { base64StringToBlob } from 'blob-util'
import _ from 'lodash'
import { isMatchWith, remove, flow, map, join, replace, isInteger, isEmpty, filter } from 'lodash/fp'
import moment from 'moment'

import { getAppConfig } from 'deploy-env/app-config'
import { PAYMENT_TYPE } from 'e-submission/domain/data-model/constants'
import { getToggles } from 'quick-quote/feature-toggles'

import VALUE from '../../core/data-model/constants/values'

export const IsRealDevice = typeof window === 'object' && !isEmpty(window.cordova)

export const isInCall = (app) => {
  return _.get(app, 'remoteSelling.callStatus.isInCall')
}

export const isProdEnv = getAppConfig().OC_ENVIRONMENT === 'prod'
export const isCordova = false
export const isDisable2ndDoc = () => {
  return getToggles().ENABLE_EKYC_F2F && getToggles().ENABLE_DISABLE_SECOND_DOC
}

export const when = (condition, fn) => (value) => {
  if (condition(value)) {
    return fn(value)
  }
  return value
}

export const isAppIdPaidPayment = (applications) => {
  const paymentWithPaid =
    applications.receipts.length > 0 && applications.receipts.find((receipt) => receipt?.receiptNo && receipt?.paid)
  return paymentWithPaid
}

export const isPaidPayment = (appWithID) => {
  const { policy } = appWithID
  const paymentWithPaid =
    policy.receipts.length > 0 && policy.receipts.find((receipt) => receipt?.receiptNo && receipt?.paid)
  return paymentWithPaid
}

export const checkPaymentType = (appWithID) => {
  const receipt = isPaidPayment(appWithID) || {}
  return receipt?.type
}

export const isPolicyExpired = (appWithID) => {
  const currentDate = moment()
  const numberOfDayValidateAppCreated = getAppConfig().NUMBER_OF_DAY_VALIDATE_APP_CREATED
  const validateDayAppCreated = moment(appWithID.createdAt)
    .add(numberOfDayValidateAppCreated, 'days')
    .isBefore(currentDate)
  return validateDayAppCreated
}

export const haveEcbr = (appWithID) => {
  const { policy } = appWithID
  const ecbrIssue =
    policy.receipts.length > 0 &&
    policy.receipts.find((receipt) => receipt?.receiptNo && receipt?.signed && receipt?.paid)
  return ecbrIssue
}

export const productDisableFlag = (appWithID) => {
  const productExpiryDT = appWithID.productExpiryDate ? moment(appWithID.productExpiryDate).format() : null
  const productCode = appWithID.productCode
  const isHiddenProduct = !appWithID.isProductDisplay
  // Use Date.now for date mocking purpose in test
  const dateNow = moment(Date.now()).format()
  const isExpire = appWithID.productExpiryDate ? moment(productExpiryDT).isBefore(dateNow) : false

  let toggleProductFlag = false
  switch (productCode) {
    case '25PL':
      toggleProductFlag = getToggles().SHOW_PRODUCT_25PL
      break
    case VALUE['5WL85']:
      toggleProductFlag = getToggles().SHOW_PRODUCT_5WL85
      break
    case 'RPUDR':
      toggleProductFlag = getToggles().SHOW_PRODUCT_RPUDR
      break
    case VALUE.ICARE:
      toggleProductFlag = getToggles().SHOW_PRODUCT_ICARE
      break
    case VALUE.IGROW:
      toggleProductFlag = getToggles().SHOW_PRODUCT_IGROW
      break
    case '25P15':
      toggleProductFlag = getToggles().SHOW_PRODUCT_25P15
      break
    case '20P10':
      toggleProductFlag = getToggles().SHOW_PRODUCT_20P10
      break
    case 'FWLNP85':
      toggleProductFlag = getToggles().SHOW_PRODUCT_FLEXI_HEALTH
      break
    case '25P15S':
      toggleProductFlag = getToggles().SHOW_PRODUCT_25P15S
      break
    case '20P10S':
      toggleProductFlag = getToggles().SHOW_PRODUCT_20P10S
      break
    case 'W85P10J':
      toggleProductFlag = getToggles().SHOW_PRODUCT_W85P10J
      break
    case 'W85P10S':
      toggleProductFlag = getToggles().SHOW_PRODUCT_W85P10S
      break
    case 'WL88J':
      toggleProductFlag = getToggles().SHOW_PRODUCT_WL88J
      break
    case 'WL88S':
      toggleProductFlag = getToggles().SHOW_PRODUCT_WL88S
      break
    case 'R01':
      toggleProductFlag = getToggles().SHOW_PRODUCT_IRETIRE_R01
      break
    case 'R05':
      toggleProductFlag = getToggles().SHOW_PRODUCT_IRETIRE_R05
      break
    case 'PLB05':
      toggleProductFlag = getToggles().SHOW_PRODUCT_PLB05
      break
    case 'PLB10':
      toggleProductFlag = getToggles().SHOW_PRODUCT_PLB10
      break
    case 'PLB12':
      toggleProductFlag = getToggles().SHOW_PRODUCT_PLB12
      break
    case 'PLB15':
      toggleProductFlag = getToggles().SHOW_PRODUCT_PLB15
      break
    default:
      toggleProductFlag = true
  }
  const isToggleoff = !toggleProductFlag
  return isExpire || isToggleoff || isHiddenProduct
}

export const housekeepingStatusSignedFlow = (appWithID) => {
  const enabledHouseKeeping = getToggles().ENABLE_DRAFT_HOUSE_KEEPING

  let disable = false
  let statusSigned = null

  const policyCheckExpiredFlow = isPolicyExpired(appWithID) || productDisableFlag(appWithID)
  const policyCheckPaymentTypeAndEcbrFlow = isPolicyExpired(appWithID) || productDisableFlag(appWithID)

  if (isPaidPayment(appWithID)) {
    if (checkPaymentType(appWithID) === PAYMENT_TYPE.CREDITCARD) {
      statusSigned = policyCheckPaymentTypeAndEcbrFlow ? 'signed-over' : statusSigned
    } else {
      if (haveEcbr(appWithID)) {
        statusSigned = policyCheckPaymentTypeAndEcbrFlow ? 'signed-over' : statusSigned
      } else {
        disable = policyCheckExpiredFlow
        statusSigned = policyCheckExpiredFlow ? 'signed-disabled' : statusSigned
      }
    }
  } else {
    disable = policyCheckExpiredFlow
    statusSigned = policyCheckExpiredFlow ? 'signed-disabled' : statusSigned
  }
  return {
    disabled: enabledHouseKeeping && disable,
    statusSigned: enabledHouseKeeping ? statusSigned : null,
  }
}

export const housekeepingStatusDraftedFlow = (appWithID) => {
  const enabledHouseKeeping = getToggles().ENABLE_DRAFT_HOUSE_KEEPING

  let disable = false
  let statusSigned = null

  const policyCheckExpiredFlow = isPolicyExpired(appWithID) || productDisableFlag(appWithID)
  disable = policyCheckExpiredFlow
  statusSigned = policyCheckExpiredFlow ? 'drafted-disabled' : statusSigned

  return {
    disabled: enabledHouseKeeping && disable,
    statusSigned: enabledHouseKeeping ? statusSigned : null,
  }
}

export const addSignedDateStatus = (createdAt, productDisable) => {
  const signedOverDate = moment(createdAt)
    .add(30, 'days')
    .format()
  // Use Date.now for date mocking purpose in test
  const dateNow = moment(Date.now()).format()
  const isSignedOverDate = moment(signedOverDate).isBefore(dateNow)
  return productDisable ? 'signed-disabled' : isSignedOverDate ? 'signed-over' : null
}

export const mapProductsConfigToApp = (appWithId, productState) => {
  const productConfig = {
    product: flow(filter((product) => product?.code === appWithId?.quickQuote?.selectedDisplayProduct?.code))(
      productState?.products?.payload
    ),
    isProductDisplay: Array.isArray(productState?.productDisplays)
      ? productState?.productDisplays?.indexOf(appWithId?.quickQuote?.selectedDisplayProduct?.code) > -1
      : false,
  }
  const appWithIdAndProduct = Object.assign(productConfig, appWithId)
  return appWithIdAndProduct
}

export const mapModelFactorToApp = (appWithId, state) => {
  return {
    modelFactor: flow(
      filter((modelFactor) => modelFactor?.id === appWithId?.quickQuote?.coveragePlan?.selectedModelFactorID)
    )(state?.modelFactors?.payload),
  }
}

export const toPathString = flow(
  map((name) => {
    if (isInteger(name)) {
      return `[${name}]`
    }

    return name
  }),
  join('.'),
  replace(/\.\[/g, '[')
)

export const isShallowEqual = isMatchWith((a, b) => a === b)

export const updateOnChange = (resolver, callback) => {
  let prev = resolver()
  return () => {
    if (!isShallowEqual(prev, resolver())) {
      prev = resolver()
      callback()
    }
  }
}

export const emitter = () => {
  const subscribers = []

  const subscribe = (sub) => {
    subscribers.push(sub)
    return () => remove(subscribers, sub)
  }

  const emit = (item) => {
    const arr = subscribers.slice()
    for (let i = 0, len = arr.length; i < len; i++) {
      arr[i](item)
    }
  }

  return {
    subscribe,
    emit,
  }
}

export const base64ToBlob = (base64, contentType = '', sliceSize = 512) => {
  // Defensive checks
  if (!base64 || typeof window === 'undefined') {
    return new Blob([], { type: contentType })
  }

  // If a data URL is passed, strip the prefix (e.g. data:<type>;base64,AAA...)
  let base64String = typeof base64 === 'string' ? base64.replace(/^data:.*;base64,/, '') : ''

  // Remove any whitespace/newlines
  base64String = base64String.replace(/\s/g, '')

  // Convert URL-safe base64 to standard base64
  base64String = base64String.replace(/-/g, '+').replace(/_/g, '/')

  // Pad with '=' to make length a multiple of 4
  const padLen = base64String.length % 4
  if (padLen > 0) {
    base64String += '='.repeat(4 - padLen)
  }

  // Quick validation: after normalization, the string should only contain base64 chars
  // If it doesn't, return an empty blob to avoid atob InvalidCharacterError
  if (!/^[A-Za-z0-9+/=]*$/.test(base64String)) {
    console.warn('base64ToBlob: input contains invalid base64 characters')
    return new Blob([], { type: contentType })
  }

  try {
    const byteCharacters = window.atob(base64String)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, { type: contentType })
  } catch (err) {
    // If atob fails, log and return an empty blob to avoid uncaught exceptions in UI
    console.error('base64ToBlob: failed to decode base64 string', err)
    return new Blob([], { type: contentType })
  }
}

export const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onerror = (err) => reject(err)

    reader.onload = (evt) => resolve(evt.target.result)

    reader.readAsDataURL(blob)
  })

export const blobToText = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onerror = (err) => reject(err)

    reader.onload = (evt) => resolve(evt.target.result)

    reader.readAsText(blob)
  })

export const removeZeroWidthSpaces = (text) => {
  // There are more invisible characters than this list
  return text.replace(/[\u200B-\u200D\uFEFF]/g, '')
}

/* DIGSALTOOL-1659  */
export const prepareEkycDetailResult = (detail) => {
  const frontIdCardResult = {}
  const backIdCardResult = {}
  const dopaResult = {}
  const idFaceRecognitionResult = {}
  const passportResult = {}
  const insurancePolicyAgreementResult = {}

  // passportResult section
  if (_.get(detail, 'passportResult.edits', null) === null) {
    passportResult.firstName = _.get(detail, 'passportResult.response.result.firstName', '-')
    passportResult.lastName = _.get(detail, 'passportResult.response.result.lastName', '-')
    passportResult.dateOfBirth = _.get(detail, 'passportResult.response.result.dateOfBirth', '-')
    passportResult.dateOfExpiry = _.get(detail, 'passportResult.response.result.dateOfExpiry', '-')
    passportResult.passportNumber = _.get(detail, 'passportResult.response.result.passportNumber', '-')
    passportResult.issuingState = _.get(detail, 'passportResult.response.result.issuingState', '-')
    passportResult.gender = _.get(detail, 'passportResult.response.result.gender', '-')
    passportResult.nationality = _.get(detail, 'passportResult.response.result.nationality', '-')
  } else {
    passportResult.firstName = _.get(detail, 'passportResult.edits.firstName', '-')
    passportResult.lastName = _.get(detail, 'passportResult.edits.lastName', '-')
    passportResult.dateOfBirth = _.get(detail, 'passportResult.edits.dateOfBirth', '-')
    passportResult.dateOfExpiry = _.get(detail, 'passportResult.edits.dateOfExpiry', '-')
    passportResult.passportNumber = _.get(detail, 'passportResult.edits.passportNumber', '-')
    passportResult.issuingState = _.get(detail, 'passportResult.edits.issuingState', '-')
    passportResult.gender = _.get(detail, 'passportResult.edits.gender', '-')
    passportResult.nationality = _.get(detail, 'passportResult.edits.nationality', '-')
  }
  passportResult.idCardImageUrl = _.get(detail, 'passportResult.response.idCardImageUrl', null)

  // frontIdCardResult section
  if (_.get(detail, 'frontIdCardResult.edits', null) === null) {
    frontIdCardResult.titleTh = _.get(detail, 'frontIdCardResult.response.result.title_th', '-')
    frontIdCardResult.titleEn = _.get(detail, 'frontIdCardResult.response.result.title_en', '-')
    frontIdCardResult.firstNameTh = _.get(detail, 'frontIdCardResult.response.result.first_name_th', '-')
    frontIdCardResult.lastNameTh = _.get(detail, 'frontIdCardResult.response.result.last_name_th', '-')
    frontIdCardResult.citizenId = _.get(detail, 'frontIdCardResult.response.result.id_number', '-')
    frontIdCardResult.dateOfBirth = _.get(detail, 'frontIdCardResult.response.result.date_of_birth_th', '-')
    frontIdCardResult.address = _.get(detail, 'frontIdCardResult.response.result.address_th', '-')
  } else {
    frontIdCardResult.titleTh = _.get(detail, 'frontIdCardResult.edits.titleTh', '-')
    frontIdCardResult.titleEn = _.get(detail, 'frontIdCardResult.edits.titleEn', '-')
    frontIdCardResult.firstNameTh = _.get(detail, 'frontIdCardResult.edits.firstNameTh', '-')
    frontIdCardResult.lastNameTh = _.get(detail, 'frontIdCardResult.edits.lastNameTh', '-')
    frontIdCardResult.citizenId = _.get(detail, 'frontIdCardResult.edits.citizenId', '-')
    frontIdCardResult.dateOfBirth = _.get(detail, 'frontIdCardResult.edits.dateOfBirth', '-')
    frontIdCardResult.address = _.get(detail, 'frontIdCardResult.edits.address', '-')
  }
  frontIdCardResult.idCardImageUrl = _.get(detail, 'frontIdCardResult.response.idCardImageUrl', null)

  // backIdCardResult section
  if (_.get(detail, 'backIdCardResult.edits', null) === null) {
    backIdCardResult.laser = _.get(detail, 'backIdCardResult.response.result.laser_code', '-')
  } else {
    backIdCardResult.laser = _.get(detail, 'backIdCardResult.edits.laser', '-')
  }

  // idFaceRecognitionResult section
  idFaceRecognitionResult.idFaceRecognitionImageUrl = _.get(
    detail,
    'idFaceRecognitionResult.idFaceRecognitionImageUrl',
    null
  )
  idFaceRecognitionResult.response = _.get(detail, 'idFaceRecognitionResult.response', null)
  idFaceRecognitionResult.verified = _.get(detail, 'idFaceRecognitionResult.verified', null)
  idFaceRecognitionResult.feedback = _.get(detail, 'idFaceRecognitionResult.feedback', null)

  // dopaResult section
  dopaResult.verified = _.get(detail, 'dopaResult.verified', null)
  dopaResult.dopaRequestFailed = _.get(detail, 'dopaResult.dopaRequestFailed', null)
  dopaResult.message = _.get(detail, 'dopaResult.response.data.message', '-')

  // insurancePolicyAgreementResult section
  insurancePolicyAgreementResult.verified = _.get(detail, 'insurancePolicyAgreementResult.verified', false)
  insurancePolicyAgreementResult.confirmed = _.get(detail, 'insurancePolicyAgreementResult.confirmed', false)
  insurancePolicyAgreementResult.resultDocumentUrl = _.get(
    detail,
    'insurancePolicyAgreementResult.resultDocumentUrl',
    null
  )
  insurancePolicyAgreementResult.resultDocumentKey = _.get(
    detail,
    'insurancePolicyAgreementResult.resultDocumentKey',
    null
  )
  insurancePolicyAgreementResult.response = _.get(detail, 'insurancePolicyAgreementResult.response', false)

  return {
    frontIdCardResult,
    backIdCardResult,
    dopaResult,
    idFaceRecognitionResult,
    passportResult,
    insurancePolicyAgreementResult,
  }
}

export const getVerificationDetail = (verificationDetail) => {
  let frontIdCardResult = null
  let backIdCardResult = null
  let dopaResult = null
  let idFaceRecognitionResult = null
  let passportResult = null
  let insurancePolicyAgreementResult = null
  let detail = verificationDetail
  const status = _.get(verificationDetail, 'status', 'in_progress')
  const reusedResults = _.get(detail, 'reusedResults', [])

  // insurancePolicyAgreementResult section
  if (_.get(detail, 'insurancePolicyAgreementResult', null)) {
    insurancePolicyAgreementResult = {
      verified: _.get(detail, 'insurancePolicyAgreementResult.verified', false),
      confirmed: _.get(detail, 'insurancePolicyAgreementResult.confirmed', false),
      resultDocumentUrl: _.get(detail, 'insurancePolicyAgreementResult.resultDocumentUrl', null),
      resultDocumentKey: _.get(detail, 'insurancePolicyAgreementResult.resultDocumentKey', null),
      response: {
        confirmationAccepted:
          _.get(detail, 'insurancePolicyAgreementResult.response.confirmationAccepted', false) ?? false,
        resultDocumentUrl: _.get(detail, 'insurancePolicyAgreementResult.resultDocumentUrl', null),
        resultDocumentKey: _.get(detail, 'insurancePolicyAgreementResult.resultDocumentKey', null),
      },
    }
  }

  if (!_.isEmpty(reusedResults) && status === 'verified') {
    detail = _.get(verificationDetail, 'verification', null)
  }

  // passportResult section
  if (_.get(detail, 'passportResult', null)) {
    passportResult = {
      response: {
        idCardImageKey: _.get(detail, 'passportResult.response.idCardImageKey', null),
        idCardImageUrl: _.get(detail, 'passportResult.response.idCardImageUrl', null),
        result: {
          firstName: _.get(detail, 'passportResult.response.result.firstName', '-'),
          lastName: _.get(detail, 'passportResult.response.result.lastName', '-'),
          passportNumber: _.get(detail, 'passportResult.response.result.passportNumber', '-'),
          dateOfBirth: _.get(detail, 'passportResult.response.result.dateOfBirth', '-'),
          dateOfExpiry: _.get(detail, 'passportResult.response.result.dateOfExpiry', '-'),
          issuingState: _.get(detail, 'passportResult.response.result.issuingState', '-'),
          gender: _.get(detail, 'passportResult.response.result.gender', '-'),
          nationality: _.get(detail, 'passportResult.response.result.nationality', '-'),
        },
      },
      verified: _.get(detail, 'passportResult.verified', false),
      updatedAt: _.get(detail, 'passportResult.updatedAt', null),
    }
    if (_.get(detail, 'passportResult.edits', null)) {
      passportResult.edits = {
        firstName: _.get(detail, 'passportResult.edits.firstName', '-'),
        lastName: _.get(detail, 'passportResult.edits.lastName', '-'),
        passportNumber: _.get(detail, 'passportResult.edits.passportNumber', '-'),
        dateOfBirth: _.get(detail, 'passportResult.edits.dateOfBirth', '-'),
        dateOfExpiry: _.get(detail, 'passportResult.edits.dateOfExpiry', '-'),
        issuingState: _.get(detail, 'passportResult.edits.issuingState', '-'),
        gender: _.get(detail, 'passportResult.edits.gender', '-'),
        nationality: _.get(detail, 'passportResult.edits.nationality', '-'),
      }
    }
  }

  // frontIdCardResult section
  if (_.get(detail, 'frontIdCardResult', null)) {
    frontIdCardResult = {
      response: {
        idCardImageKey: _.get(detail, 'frontIdCardResult.response.idCardImageKey', null),
        idCardImageUrl: _.get(detail, 'frontIdCardResult.response.idCardImageUrl', null),
        result: {
          title_th: _.get(detail, 'frontIdCardResult.response.result.title_th', '-'),
          first_name_th: _.get(detail, 'frontIdCardResult.response.result.first_name_th', '-'),
          last_name_th: _.get(detail, 'frontIdCardResult.response.result.last_name_th', '-'),
          id_number: _.get(detail, 'frontIdCardResult.response.result.id_number', '-'),
          date_of_birth_th: _.get(detail, 'frontIdCardResult.response.result.date_of_birth_th', '-'),
          address_th: _.get(detail, 'frontIdCardResult.response.result.address_th', '-'),
        },
      },
      verified: _.get(detail, 'frontIdCardResult.verified', false),
      updatedAt: _.get(detail, 'frontIdCardResult.updatedAt', null),
    }
    if (_.get(detail, 'frontIdCardResult.edits', null)) {
      frontIdCardResult.edits = {
        titleTh: _.get(detail, 'frontIdCardResult.edits.titleTh', '-'),
        firstNameTh: _.get(detail, 'frontIdCardResult.edits.firstNameTh', '-'),
        lastNameTh: _.get(detail, 'frontIdCardResult.edits.lastNameTh', '-'),
        citizenId: _.get(detail, 'frontIdCardResult.edits.citizenId', '-'),
        dateOfBirth: _.get(detail, 'frontIdCardResult.edits.dateOfBirth', '-'),
        address: _.get(detail, 'frontIdCardResult.edits.address', '-'),
      }
    }
  }

  // backIdCardResult section
  if (_.get(detail, 'backIdCardResult', null)) {
    backIdCardResult = {
      response: {
        result: {
          laser_code: '-',
        },
      },
      verified: _.get(detail, 'backIdCardResult.verified', false),
    }
    if (_.get(detail, 'backIdCardResult.edits', null)) {
      backIdCardResult.edits = {
        laser: '-',
      }
    }
  }
  // idFaceRecognitionResult section
  if (_.get(detail, 'idFaceRecognitionResult', null)) {
    idFaceRecognitionResult = {
      response: {
        idFaceRecognitionImageUrl: _.get(detail, 'idFaceRecognitionResult.idFaceRecognitionImageUrl', null),
        faceImageUrl: _.get(detail, 'idFaceRecognitionResult.faceImageUrl', null),
        Similarity: _.get(detail, 'idFaceRecognitionResult.response.Similarity', null),
      },
      verified: _.get(detail, 'idFaceRecognitionResult.verified', false),
      feedback: _.get(detail, 'feedback', ''),
    }
  }

  // dopaResult section
  if (_.get(detail, 'dopaResult', null)) {
    dopaResult = {
      response: {
        data: {
          message: getToggles().ENABLE_MOCK_DOPA_REQUEST_FAIL
            ? 'mock dopa request fail'
            : _.get(detail, 'dopaResult.response.message', '-'),
        },
      },
      verified: getToggles().ENABLE_MOCK_DOPA_VERIFIED_FAIL ? false : _.get(detail, 'dopaResult.verified', false),
      dopaRequestFailed: getToggles().ENABLE_MOCK_DOPA_REQUEST_FAIL
        ? true
        : _.get(detail, 'dopaResult.dopaRequestFailed', null),
    }
  }

  return {
    frontIdCardResult,
    backIdCardResult,
    dopaResult,
    idFaceRecognitionResult,
    passportResult,
    insurancePolicyAgreementResult,
  }
}
export const getMetaData = (data) => {
  return typeof data === 'string' ? JSON.parse(data) : data
}
export const toDataURL = (url, options = {}) =>
  fetch(url, options)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
    )

export const convertImageUrlToBlob = async (file) => {
  const dataUrl = await toDataURL(file.url)
  return base64StringToBlob(dataUrl.replace(/^.*base64,/, ''), file.fileType)
}

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
}

export const setWithExpiry = (key, value, ttl) => {
  const now = new Date()
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}
